import React from 'react';
import { BookOpenIcon } from 'lucide-react';
export function ProductIntro() {
  return <section className="py-12 px-4 sm:px-6 lg:px-8" data-id="element-171">
      <div className="max-w-4xl mx-auto text-center" data-id="element-172">
        <div className="inline-flex items-center gap-2 px-6 py-3 bg-[#5BB4A0]/10 border border-[#5BB4A0]/30 rounded-full mb-4 shadow-sm" data-id="element-173">
          <BookOpenIcon className="w-5 h-5 text-[#5BB4A0]" data-id="element-174" />
          <span className="font-bold text-[#1A1A1A]" data-id="element-175">¿QUÉ INCLUYE TU KIT?</span>
        </div>
        <p className="text-xl text-[#6B7280]" data-id="element-176">
          3 Tomos + 1 Bonus + Manual del Reintegro — Edición 2026
        </p>
      </div>
    </section>;
}